import type { QueryClient } from "@tanstack/react-query";

import { isConnected } from "@src/utils/checkConnection";
import { exitOfflineMode } from "@src/utils/offline/exitOfflineMode";

/**
 * Verifica se há internet e, se houver, chama exitOfflineMode.
 * Retorna true se o modo offline foi encerrado, false caso contrário.
 */
export async function tryExitOfflineMode(
  queryClient: QueryClient,
  playingOrPaused: "playing" | "paused" | null,
): Promise<boolean> {
  const online = await isConnected();
  if (online) {
    exitOfflineMode(playingOrPaused, queryClient);
    return true;
  }
  return false;
}
